import { Avatar, Box, useTheme } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcLink } from "components/MprcLink";
import { useModalUserProfile } from "providers/UserProfileProvider";
import React from "react";
import { useLocation, useNavigate } from "react-router";

interface IProps {
    user: AppUser;
    publicationId?: string;
}

export const MprcUserAvatarProfileLink: React.FC<IProps> = (props) => {

    const { user, publicationId } = props;
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { showUser } = useModalUserProfile();

    return (
        <>
            <MprcLink
                onClick={
                    () => showUser(
                        user.userId,
                        () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: publicationId } })
                    )
                }
            >
                <Box sx={{
                    margin: "0 auto",
                    overflow: "hidden",
                    marginRight: "15px",
                    borderRadius: "50%",
                    backgroundColor: theme.palette["muted"].light
                }}>
                    <Avatar
                        sx={{
                            width: 48,
                            height: 48
                        }}
                        title={user.name}
                        src={user.thumbnailUrl ?? AppImages.UserThumbnail}
                    />
                </Box>
            </MprcLink>
        </>
    );
};
